import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getGeoService = async (site_uuid, startDate = null, endDate = null) => {
  try {
    let query = supabase
      .from("site_patrol_geolocation")
      .select()
      .eq("site_uuid", site_uuid);
    
    if (startDate && endDate) {
      query = query
        .gte("created_at", startDate)
        .lte("created_at", endDate + "T23:59:59");
    }
    
    const { data, error } = await query.order("id", { ascending: false });
    
    if (error) {
      console.error("Error fetching geolocation data:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getGeoService:", error);
    return null;
  }
};

export const getAllSitesGeoService = async (account_uuid) => {
  // ดึง site_uuid ทั้งหมดที่อยู่ภายใต้ account
  const { data: siteData } = await supabase
    .from("account_site")
    .select("site_uuid")
    .eq("account_uuid", account_uuid);

  if (!siteData?.length) return [];

  // ดึงข้อมูล geolocation ของทุก site พร้อมกัน
  const geoPromises = siteData.map(site => getGeoService(site.site_uuid));
  const geoResults = await Promise.all(geoPromises);

  // รวมข้อมูล geolocation ทั้งหมดเข้าด้วยกัน
  return geoResults.flat();
};

